import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
const Privacy = resolve => require(['@/components/Privacy'], resolve)
const Terms = resolve => require(['@/components/Terms'], resolve)
const About = resolve => require(['@/components/About'], resolve)
const Contact = resolve => require(['@/components/Contact'], resolve)
const Gallery = resolve => require(['@/components/Gallery'], resolve)

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      afterEach: (to, next) => {
        this.$store.commit('hidePdf')
      }
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: Privacy
    },
    {
      path: '/terms',
      name: 'Terms',
      component: Terms
    },
    {
      path: '/gallery',
      name: 'Gallery',
      component: Gallery
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js